<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          {{ $t('free_trial_page_title') }}
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('free_trial_search_schools')"
            single-line
            hide-details
            @input="onSearch"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="schools"
          :loading="loading"
          item-key="id"
          :page.sync="page"
          :items-per-page.sync="itemsPerPage"
          :server-items-length="totalItems"
          :footer-props="{
            'items-per-page-options': [5, 10, 25, 50]
          }"
          class="elevation-1"
          @update:page="onPageChange"
          @update:items-per-page="onItemsPerPageChange"
        >
          <template #item.free_trial="{ item }">
            <v-switch
              :input-value="!!item.free_trial"
              @change="val => onToggle(item, val)"
              :loading="item.__saving === true"
              inset
              color="success"
            ></v-switch>
          </template>
          <template #item.free_trial_status="{ item }">
            <v-chip
              small
              :color="statusChipColor(item.free_trial_status)"
              text-color="white"
            >
              {{ $t(statusLabelKey(item.free_trial_status)) }}
            </v-chip>
          </template>
          <template #item.free_trial_ends_at="{ item }">
            <span>{{ formatEndAt(item) }}</span>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import FreeTrialService from '@/services/FreeTrialService.js'

export default {
  data() {
    return {
      loading: false,
      schools: [],
      search: '',
      page: 1,
      itemsPerPage: 10,
      totalItems: 0,
    };
  },
  computed: {
    headers() {
      return [
        { text: 'ID', value: 'id' },
        { text: this.$t('free_trial_col_name'), value: 'name' },
        { text: this.$t('free_trial_col_email'), value: 'email' },
        { text: this.$t('free_trial_col_trial'), value: 'free_trial', sortable: false },
        { text: this.$t('free_trial_col_status'), value: 'free_trial_status' },
        { text: this.$t('free_trial_col_ends_at'), value: 'free_trial_ends_at' },
      ]
    },
  },
  mounted() {
    this.fetchSchools();
  },
  methods: {
    statusLabelKey(status) {
      const key = `free_trial_status_${status || 'off'}`
      return ['off', 'active', 'expired'].includes(status) ? key : 'free_trial_status_off'
    },
    statusChipColor(status) {
      if (status === 'active') return 'success'
      if (status === 'expired') return 'warning'
      return 'grey'
    },
    formatEndAt(item) {
      const iso = item.free_trial_ends_at
      if (!iso) {
        return '—'
      }
      try {
        const d = new Date(iso)
        if (Number.isNaN(d.getTime())) {
          return '—'
        }
        return d.toLocaleString()
      } catch (e) {
        return '—'
      }
    },
    async fetchSchools() {
      this.loading = true;
      try {
        const response = await FreeTrialService.getSchoolsFreeTrial(this.page, this.itemsPerPage);
        if (response && response.success) {
          this.schools = (response.data || []).map(s => ({
            ...s,
            __saving: false,
            free_trial_status: s.free_trial_status || 'off',
          }));
          this.totalItems = response.total || 0;
        } else {
          this.$notify({ title: 'Error', text: 'Failed to load schools', type: 'error' });
        }
      } catch (error) {
        this.$notify({ title: 'Error', text: 'Failed to load schools', type: 'error' });
      } finally {
        this.loading = false;
      }
    },
    onPageChange(page) {
      this.page = page;
      this.fetchSchools();
    },
    onItemsPerPageChange(itemsPerPage) {
      this.itemsPerPage = itemsPerPage;
      this.page = 1;
      this.fetchSchools();
    },
    onSearch() {
      this.page = 1;
    },
    async onToggle(item, value) {
      item.__saving = true;
      try {
        const response = await FreeTrialService.setSchoolFreeTrial(item.id, !!value);
        if (response && response.success && response.data) {
          const d = response.data
          item.free_trial = !!d.free_trial
          if (d.free_trial_started_at !== undefined) item.free_trial_started_at = d.free_trial_started_at
          if (d.free_trial_ends_at !== undefined) item.free_trial_ends_at = d.free_trial_ends_at
          if (d.free_trial_status !== undefined) item.free_trial_status = d.free_trial_status
          this.$notify({ title: 'Saved', text: 'Updated successfully', type: 'success' });
        } else {
          throw new Error('Save failed');
        }
      } catch (error) {
        item.free_trial = !value;
        this.$notify({ title: 'Error', text: 'Failed to update', type: 'error' });
      } finally {
        item.__saving = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
